var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRectangleTag = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "a",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8 6.8h28.6v51.1H33.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.8 8.8h24.6v47.1H35.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1 12.1a3.3 3.3 0 1 0 3.3 3.3 3.33 3.33 0 0 0-3.3-3.3Zm0 5.1a1.8 1.8 0 1 1 1.8-1.8 1.79 1.79 0 0 1-1.8 1.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m67.4 60.6 1.5-2.1a1 1 0 0 1 1.3-.2l14.3 10.1a1 1 0 0 1 .2 1.3l-1.5 2.1a1 1 0 0 1-1.3.2L67.7 61.9a.87.87 0 0 1-.3-1.3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 73.2a2 2 0 0 1-1.1-.3L67.1 62.7a1.93 1.93 0 0 1-.5-2.7l1.5-2.1a1.93 1.93 0 0 1 2.7-.5L85 67.6a2 2 0 0 1 .5 2.6L84 72.4a1.76 1.76 0 0 1-1.5.8ZM69.7 59.1l-1.5 2.1 14.3 10.1 1.5-2ZM84 69.2l.8.6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m71.342 64.153 2.598-3.674 1.551 1.097-2.598 3.674z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.2,
    cy: 53.9,
    r: 11.6,
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2 66.5a12.6 12.6 0 1 1 7.3-22.9 12.63 12.63 0 0 1-7.3 22.9Zm0-23.2a10.6 10.6 0 1 0 10.7 10.5 10.68 10.68 0 0 0-10.7-10.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2 61.1H50.4l-1.2-4h13V42.3l4 1.2v17.6z"
  })));
};
export default SvgRectangleTag;